(()=>{
  if(window.__vivaAskContextBridge)return;
  window.__vivaAskContextBridge=true;
  const params=new URLSearchParams(location.search);
  const source=(params.get('source')||params.get('utm_source')||'direct').slice(0,40);
  const collection=(params.get('collection')||'').slice(0,255);
  const product=(params.get('product')||'').slice(0,255);
  const productId=String(params.get('product_id')||'').replace(/\D/g,'').slice(0,32);
  const variantId=String(params.get('variant')||'').replace(/\D/g,'').slice(0,32);
  const variantTitle=(params.get('variant_title')||'').slice(0,120);
  const nativeFetch=window.fetch.bind(window);
  const isAskUrl=url=>/\/api\/ask-viva(?:\?|$)/.test(String(url||''));
  window.fetch=async(input,init={})=>{
    try{
      const url=typeof input==='string'?input:input?.url||'';
      const body=init?.body;
      if(isAskUrl(url)&&body instanceof FormData){
        if(!body.has('source'))body.append('source',source||'direct');
        if(collection&&!body.has('context_collection'))body.append('context_collection',collection);
        if(product&&!body.has('context_handle'))body.append('context_handle',product);
        if(productId&&!body.has('context_product_id'))body.append('context_product_id',productId);
        if(variantId&&!body.has('context_variant_id'))body.append('context_variant_id',variantId);
      }
    }catch(_){}
    return nativeFetch(input,init);
  };
  const root=document.querySelector('[data-viva-ask-root]');
  if(!root)return;
  root.dataset.vivaEntrySource=source;
  root.dataset.vivaContextMode=product?'product_led':collection?'family_led':'room_first';
  root.dataset.vivaContextBridge='exact-pdp-v1';
  if(product)root.dataset.vivaContextHandle=product;
  if(productId)root.dataset.vivaContextProductId=productId;
  if(variantId)root.dataset.vivaContextVariantId=variantId;

  const createCard=()=>{
    if(!product||document.querySelector('[data-viva-exact-piece]'))return null;
    const card=document.createElement('aside');
    card.dataset.vivaExactPiece='';
    card.className='viva-ask__exact-piece';
    card.innerHTML=`<p class="viva-ask__eyebrow">YOU’RE PREVIEWING THIS EXACT PIECE</p><div class="viva-ask__exact-piece-row"><div data-viva-exact-piece-image></div><div><strong data-viva-exact-piece-title>Selected Viva product</strong><span data-viva-exact-piece-variant>${variantTitle||'Selected variant'}</span><p>Ask Viva will place this selected product into a physically plausible spot in your real room. It will not substitute a similar SKU.</p></div></div>`;
    const style=document.createElement('style');
    style.textContent='.viva-ask__exact-piece{margin:0 0 1.5rem;padding:1.2rem;border:1px solid rgba(20,68,51,.18);border-radius:1rem;background:#f8f5ee}.viva-ask__exact-piece-row{display:grid;grid-template-columns:76px 1fr;gap:1rem;align-items:center}.viva-ask__exact-piece img{width:76px;height:76px;object-fit:contain;border-radius:.6rem;background:#fff}.viva-ask__exact-piece strong,.viva-ask__exact-piece span{display:block}.viva-ask__exact-piece span{margin:.2rem 0 .4rem;opacity:.72;font-size:.92em}.viva-ask__exact-piece p{margin:.35rem 0 0;line-height:1.45;font-size:.92em}@media(max-width:480px){.viva-ask__exact-piece-row{grid-template-columns:64px 1fr}.viva-ask__exact-piece img{width:64px;height:64px}}';
    document.head.appendChild(style);
    root.prepend(card);
    return card;
  };
  const card=createCard();
  if(card&&product){
    nativeFetch(`/products/${encodeURIComponent(product)}.js`,{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).then(p=>{
      if(!p)return;
      const requested=variantId?String(variantId):'';
      let variant=requested?(p.variants||[]).find(v=>String(v.id)===requested)||null:null;
      if(!variant&&(p.variants||[]).length===1)variant=p.variants[0];
      const title=card.querySelector('[data-viva-exact-piece-title]');
      const variantEl=card.querySelector('[data-viva-exact-piece-variant]');
      if(title)title.textContent=p.title||'Selected Viva product';
      if(variantEl)variantEl.textContent=variant?.public_title||variant?.title||variantTitle||'Selected variant';
      const src=variant?.featured_image?.src||variant?.featured_image||p.featured_image||p.images?.[0]||'';
      const holder=card.querySelector('[data-viva-exact-piece-image]');
      if(holder&&src){const img=document.createElement('img');img.src=src;img.alt=`${p.title||'Viva product'} — ${variant?.title||'selected variant'}`;img.loading='eager';holder.appendChild(img);}
      if(variantId&&(!variant||String(variant.id)!==variantId))root.dataset.vivaContextInvalid='variant_mismatch';
    }).catch(()=>{});
  }
})();
